import packageInfo from '../../package.json';

export const environment = {
  production: true,
  name: packageInfo.name,
  environment: 'Staging',
  apiRoute: 'https://journal-sandbox-server.stemtaught.com',
  sentry: {
    DSN: 'https://c8b94b39328c4ec3a9df2f09441993e6@o68356.ingest.sentry.io/5710319',
    autoSessionTracking: false,
    enabled: true,
    dialogEnabled: true,
  },
  version: packageInfo.version,
};
